import React from "react";
import ChatBubble from 'shared/components/ChatBubble';

const Testing = () => {
    return(
        <div className="testing-main">
            <ChatBubble/>
        </div>
    )
}

export default Testing;